export default __webpack_public_path__ + "static/media/section2a-card4img.2c4ea957.svg";